import 'pages/Home/Home.css';
import About from 'components/About';
import Location from 'components/Location'
import TestimonialsSection from 'components/TestimonialsSection';
import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';

// Import resources
import home_logo from 'res/only_writing.webp';
import ayce from 'res/ayce.webp';
import BackToTop from 'components/BackToTop';

const Home = () => {
    const { t } = useTranslation();

    // Set page title correctly
    useEffect(() => {
        document.title = "Umi Sushi";
    }, []);

    return (
        <div className="homepage-container">
            <BackToTop />
            <div className="home-section">
                <div className="home-content">
                    <img src={home_logo} className="home-logo" alt="logo" />
                    <img src={ayce} className="ayce-logo" alt="all you can eat" />
                    <a className='call-button' href="tel:+351289153829" target="_blank" role="button" rel="noreferrer">{t('contact-us')}</a> 
                </div>
            </div>
            <About />
            <Location />
            <TestimonialsSection />
        </div>
    )
    
};

export default Home;